// export const token = "8lQzN922rpRDaMbh3m5J";

const tokenValue = sessionStorage.getItem("token");
export const tokenHeader = { Authorization: `Bearer ${tokenValue}` };

export const config = {
  headers: { Authorization: `Bearer ${tokenValue}` },
};

export const getConfig = () => ({
  headers: {
    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  },
});
export const BASE_URL = "https://backend.iqlabs.io/api/evChargers";

export const TEST_URL = "https://testing.iqlabs.io/backend/api/evChargers";

// export const INVOICE_URL = "https://testing.iqlabs.io/invoice/api";

export const REPORT_URL = "http://localhost:4000/api/";

// export const BASE_URL = "http://localhost:8089/api/evChargers";
